import * as React from 'react'

import Head from 'next/head'

import { PrefetchTagAttributes } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Product'

import { useProductPage } from '../../context'

export interface PrefetchTagProps {
  defaults: PrefetchTagAttributes[]
  variants: {
    [sku: number]: { defaults: PrefetchTagAttributes[] }
  }
}

export const PrefetchTags: React.FunctionComponent<PrefetchTagProps> = (
  props,
) => {
  const { selectedVariant } = useProductPage()

  return (
    <Head>
      {props.defaults.map(({ rel, as, href, fetchpriority }, index) => (
        <link
          rel={rel}
          href={href}
          key={`prefetch_default_${index}`}
          as={as}
          fetchpriority={fetchpriority}
        />
      ))}
      {selectedVariant &&
        props.variants[selectedVariant.sku] &&
        props.variants[
          selectedVariant.sku
        ].defaults.map(({ rel, as, href }, index) => (
          <link
            rel={rel}
            href={href}
            key={`prefetch_variant_${selectedVariant!.sku}_${index}`}
            as={as}
          />
        ))}
    </Head>
  )
}
